const pageNameKey = "renderRestructuringSummaryNodesPillElement";

export const renderRestructuringSummaryNodesPillElementEn = {
  [pageNameKey]: {
    allNodesFoundSuccessfully: "All nodes found successfully",
    filterIssuesOnly: "Filter issues only",
    backToAllNodes: "Back to complete list of nodes",
    backToNodeManager: "Back to node manager",
  },
};

export const renderRestructuringSummaryNodesPillElementPtBr = {
  [pageNameKey]: {
    allNodesFoundSuccessfully: "Todos os nós foram encontrados com sucesso",
    filterIssuesOnly: "Filtrar apenas problemas",
    backToAllNodes: "Voltar para a lista completa de nós",
    backToNodeManager: "Voltar para o gerenciador de nós",
  },
};

export const renderRestructuringSummaryNodesPillElementDe = {
  [pageNameKey]: {
    allNodesFoundSuccessfully: "Alle Knoten erfolgreich gefunden",
    filterIssuesOnly: "Nur Probleme filtern",
    backToAllNodes: "Zurück zur vollständigen Liste der Knoten",
    backToNodeManager: "Zurück zum Knotenmanager",
  },
};

export const renderRestructuringSummaryNodesPillElementZhHans = {
  [pageNameKey]: {
    allNodesFoundSuccessfully: "成功找到所有节点",
    filterIssuesOnly: "仅过滤问题",
    backToAllNodes: "返回完整节点列表",
    backToNodeManager: "返回节点管理器",
  },
};

export const renderRestructuringSummaryNodesPillElementIt = {
  [pageNameKey]: {
    allNodesFoundSuccessfully: "Tutti i nodi trovati con successo",
    filterIssuesOnly: "Filtra solo i nodi con problemi",
    backToAllNodes: "Torna alla lista completa dei nodi",
    backToNodeManager: "Torna al gestore di nodi",
  },
};

export const renderRestructuringSummaryNodesPillElementEs = {
  [pageNameKey]: {
    allNodesFoundSuccessfully: "Todos los nodos se encontraron correctamente",
    filterIssuesOnly: "Filtrar solo incidencias",
    backToAllNodes: "Volver a la lista completa de nodos",
    backToNodeManager: "Volver al administrador de nodos",
  },
};

export const renderRestructuringSummaryNodesPillElementNl = {
  [pageNameKey]: {
    allNodesFoundSuccessfully: "Alle nodes succesvol gevonden",
    backToAllNodes: "Terug naar volledige lijst met nodes",
    backToNodeManager: "Terug naar nodebeheer",
    filterIssuesOnly: "Alleen problemen filteren",
  },
};

export const renderRestructuringSummaryNodesPillElementTr = {
  [pageNameKey]: {
    allNodesFoundSuccessfully: "Tüm düğümler başarıyla bulundu",
    backToAllNodes: "Düğümlerin tam listesine geri dön",
    backToNodeManager: "Düğüm yöneticisine geri dön",
    filterIssuesOnly: "Yalnızca filtre sorunları",
  },
};
